import React, { FunctionComponent } from "react";

const VideoPlayerIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/video-movies-tv/video-players/video-player
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <defs></defs>
      <title>video-player</title>
      <rect
        x="0.75"
        y="0.75"
        width="22.5"
        height="22.5"
        rx="1.5"
        ry="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></rect>
      <path
        d="M10.238,15.66A.856.856,0,0,1,9,14.894V9.106a.856.856,0,0,1,1.238-.766l5.789,2.895a.855.855,0,0,1,0,1.53Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default VideoPlayerIcon;
